import { HotelsLoadingPreview } from './HotelsLoadingPreview';

export default HotelsLoadingPreview;
